module.exports = __webpack_public_path__ + "static/media/YHMCH-Library.1d4cc026.jpg";